import { success } from "toastr";
import {
  FETCH_SERVICE,
  FETCH_SERVICE_SUCCESS,
  FETCH_SERVICE_FAILURE,
  GENERATE_SERVICE_CODE,
  GENERATE_SERVICE_CODE_SUCCESS,
  GENERATE_SERVICE_CODE_FAILURE,  
  CREATE_SERVICE_REQUEST,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_FAILURE,
  DELETE_SERVICE,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAILURE,  
  CHANGE_SERVICE_STATUS,
  CHANGE_SERVICE_STATUS_SUCCESS,
  CHANGE_SERVICE_STATUS_FAILURE
} from "./actionTypes";

const initialState = {
  service: [],
  serviceCode:'',
  loading: false,
  error: null,
  success:false
};

const timesheetSetupServiceReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_SERVICE:
      return { ...state, loading: true };
    case FETCH_SERVICE_SUCCESS:
      return { ...state, loading: false, service: action.payload.data};
    case FETCH_SERVICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GENERATE_SERVICE_CODE:
      return { ...state, loading: true };
    case GENERATE_SERVICE_CODE_SUCCESS:
      return { ...state, loading: false, serviceCode: action.payload.data};
    case GENERATE_SERVICE_CODE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHANGE_SERVICE_STATUS:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_SERVICE_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_SERVICE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case CREATE_SERVICE_REQUEST:
      return { ...state, loading: true, success:false, error: null };
    
    case CREATE_SERVICE_SUCCESS:
      return { ...state, loading: false, success:true, deductionData: action.payload, error: null };

    case CREATE_SERVICE_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_SERVICE:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_SERVICE_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_SERVICE_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };
      

    default:
      return state;
  }
};

export default timesheetSetupServiceReducer;
